var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02794IconServiceMobileNetworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edebaf98-f979-4154-9101-76108988ba81",
    x1: 307,
    y1: 388.135,
    x2: 307,
    y2: 400.896,
    gradientTransform: "matrix(1, 0, 0, -1, -298, 403.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#0068b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#0071c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0076d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4ea4d5c-fb5f-4d73-bef9-3e109b021cd3",
    x1: 4.738,
    y1: 15.38,
    x2: 4.738,
    y2: 6.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50e6ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac9a6725-7ec5-4dab-9242-0db2153ccf49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.943,15.325A4.091,4.091,0,0,0,18,11.382,4.042,4.042,0,0,0,14.489,7.5,5.1,5.1,0,0,0,9.24,2.622a5.229,5.229,0,0,0-5,3.407A4.827,4.827,0,0,0,0,10.671,4.9,4.9,0,0,0,5.07,15.377",
    fill: "url(#edebaf98-f979-4154-9101-76108988ba81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.473,15.38V10.605h0A4.745,4.745,0,0,0,4.645,6.013,4.779,4.779,0,0,0,0,10.788,4.886,4.886,0,0,0,4.738,15.38Z",
    fill: "url(#a4ea4d5c-fb5f-4d73-bef9-3e109b021cd3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.394,7.989a6.786,6.786,0,0,1,7.918-3.2.069.069,0,0,1,.029.112l-1.5,1.652a.064.064,0,0,1-.07.017c-2.508-.823-4.621-.412-6.258,1.5A.072.072,0,0,1,4.394,7.989Z",
    fill: "#86d633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.373,8.288,10.4,7.157a.055.055,0,0,0-.02-.087,4.694,4.694,0,0,0-5.8,1.617.058.058,0,0,0,.085.077c1.36-1.217,2.94-1.17,4.648-.465A.052.052,0,0,0,9.373,8.288Z",
    fill: "#86d633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.374,9.495l.612-.67a.077.077,0,0,0-.023-.118,3.565,3.565,0,0,0-4.4.869.076.076,0,0,0,.1.117,3.38,3.38,0,0,1,3.59-.176A.1.1,0,0,0,8.374,9.495Z",
    fill: "#86d633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.719,4.742a.442.442,0,0,0-.289-.31,6.587,6.587,0,0,0-2.093-.339A7.3,7.3,0,0,0,4.072,7.8a.441.441,0,0,0-.006.449.446.446,0,0,0,.232.194l-.016.019a.428.428,0,0,0-.043.452.439.439,0,0,0,.265.222c-.028.029-.057.054-.084.084a.451.451,0,0,0,.587.678,2.328,2.328,0,0,1,1.508-.433,3.731,3.731,0,0,1,1.576.393.479.479,0,0,0,.56-.108l.021-.024.591-.647a.453.453,0,0,0,.109-.383l-.006-.021A.42.42,0,0,0,9.65,8.54l.323-.354.708-.776a.422.422,0,0,0,.071-.468c.013,0,.026.006.039.006a.437.437,0,0,0,.325-.144l.639-.7.864-.949A.444.444,0,0,0,12.719,4.742ZM8.986,8.825l-.612.67a.1.1,0,0,1-.076.033.12.12,0,0,1-.048-.011,4.07,4.07,0,0,0-1.735-.429,3.206,3.206,0,0,0-1.855.605.075.075,0,0,1-.044.015.078.078,0,0,1-.053-.132A3.7,3.7,0,0,1,7.3,8.292a3.672,3.672,0,0,1,1.667.415A.077.077,0,0,1,8.986,8.825ZM10.4,7.157,9.373,8.288a.049.049,0,0,1-.037.016A.063.063,0,0,1,9.314,8.3,5.813,5.813,0,0,0,7.12,7.8a3.562,3.562,0,0,0-2.454.962.059.059,0,0,1-.038.015.058.058,0,0,1-.047-.092,4.8,4.8,0,0,1,3.85-2.036,4.878,4.878,0,0,1,1.952.419A.055.055,0,0,1,10.4,7.157ZM12.341,4.9l-1.5,1.652a.064.064,0,0,1-.048.021.057.057,0,0,1-.022,0,7.4,7.4,0,0,0-2.3-.4,5.021,5.021,0,0,0-3.96,1.9.072.072,0,0,1-.117-.083,6.969,6.969,0,0,1,5.943-3.521,6.22,6.22,0,0,1,1.975.32A.069.069,0,0,1,12.341,4.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.1,13.239v-.634a1.437,1.437,0,0,0,.751.211.717.717,0,0,0,.469-.139.467.467,0,0,0,.169-.38q0-.5-.722-.5a5.379,5.379,0,0,0-.614.04l.13-1.88H4.1v.606H2.862l-.048.675c.123-.01.229-.015.319-.015a1.188,1.188,0,0,1,.83.273.945.945,0,0,1,.3.733,1.072,1.072,0,0,1-.357.833,1.392,1.392,0,0,1-.969.323A2.117,2.117,0,0,1,2.1,13.239Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.493,13.1a2.523,2.523,0,0,1-1.252.284,1.833,1.833,0,0,1-1.308-.45A1.619,1.619,0,0,1,4.454,11.7,1.711,1.711,0,0,1,4.977,10.4a1.929,1.929,0,0,1,1.391-.5,2.872,2.872,0,0,1,.964.148v.712a1.941,1.941,0,0,0-.974-.226,1.054,1.054,0,0,0-.785.307,1.113,1.113,0,0,0-.3.818,1.114,1.114,0,0,0,.273.8.97.97,0,0,0,.735.284,1.054,1.054,0,0,0,.441-.077v-.658H6.03v-.606H7.493Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02794IconServiceMobileNetworks);
export default __webpack_public_path__ + "static/media/02794-icon-service-Mobile-Networks.9529332a5ef9294bb574c977d4e93f8b.svg";
export { ForwardRef as ReactComponent };